import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Cookies from "js-cookie";
import { keyframes } from "@emotion/react";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export default function TokenCallPopUp({
  open,
  setOpen,
  handleTokenCall,
  handleTokenComplete,
  isLoadingCall,
  tokenValue,
  checkLastCallCount,
}) {
  const handleClickClose = () => {
    setOpen(false);
    Cookies.set("isHoldToken", false);
  };
 

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="token-dialog-title"
      aria-describedby="token-dialog-description"
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
          animation: `${fadeIn} 0.3s ease-in-out`,
        },
      }}
    >
      <DialogTitle
        id="token-dialog-title"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#2552EB",
          color: "#ffffff",
          padding: "16px 24px",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Token Action
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClickClose}
          sx={{ color: "#ffffff" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "24px" }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            color: "#000000",
            textAlign: "center",
            marginTop: "10px",
            marginBottom: "8px",
          }}
        >
          What do you want to do with the current token?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px" }}>
        <Grid container spacing={2} justifyContent="flex-end">
          {Cookies.get("isHoldToken") === "true" &&
            checkLastCallCount != null && (
              <Grid item>
                <Button
                  onClick={handleTokenComplete}
                  variant="contained"
                  color="secondary"
                  disabled={isLoadingCall}
                  sx={{
                    textTransform: "capitalize",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      backgroundColor: "#1e429f",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                >
                  Complete Token
                </Button>
              </Grid>
            )}

          {checkLastCallCount != null && (
            <Grid item>
              <Button
                onClick={() => handleTokenCall(1)}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  padding: "8px 24px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  backgroundColor: "#2552EB",
                  color: "#ffffff",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: "#2552EB",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  },
                }}
                disabled={isLoadingCall}
              >
                Hold & Call
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button
              onClick={() => handleTokenCall(0)}
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                padding: "8px 24px",
                borderRadius: "8px",
                fontWeight: 600,
                borderColor: "#2552EB",
                color: "#2552EB",
                borderWidth: "2px",
                "&:hover": {
                  borderWidth: "2px",
                  backgroundColor: "#e0e7ff",
                },
              }}
              disabled={isLoadingCall}
            >
              {checkLastCallCount === undefined || checkLastCallCount === null
                ? "Call"
                : "Complete & Call"}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
